// extracted by mini-css-extract-plugin
export default {"option":"RenderText_option__r61UW","correct":"RenderText_correct__I-Rb5"};